import {
  Button,
  Input,
  Select,
  Spinner,
  Title,
} from "../uikit";
import Banner from "../components/Banner";
import Card from "../components/Card";
import { routeVariants } from "../routesVariants";
import { AnimatePresence, motion } from "motion/react";
import { useNavigate } from "react-router";
import Header from "../components/Header";
import ErrorMessage from "../components/ErrorMessage";

import { useTranslation } from "react-i18next";
import { DOMAIN } from "../consts";
import { useEffect, useState } from "react";
import { getToken, clearToken } from "../utils/tokenStorage";

export default function Settings() {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [telegramId, setTelegramId] = useState("");
  // const [theme, setTheme] = useState("");
  const [lang, setLang] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [bindEmail, setBindEmail] = useState("");
  const [bindPassword, setBindPassword] = useState("");
  const [bindCode, setBindCode] = useState("");
  const [isBindCodeSent, setIsBindCodeSent] = useState(false);
  const [isBindingEmail, setIsBindingEmail] = useState(false);
  const [bindEmailErrorMessage, setBindEmailErrorMessage] = useState("");
  const [isPasswordChanging, setIsPasswordChanging] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const navigate = useNavigate();

  // const setThemeHandler = async (event) => {
  //   const value = event.target.value;
  //   const nextTheme = value ?? "light";
  //   const token = getToken();
  //   if (token == "" || token == null) {
  //     navigate("/login");
  //     return;
  //   }
  //   const result = await fetch(DOMAIN + "/user/settings", {
  //     method: "PATCH",
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ theme: nextTheme }),
  //   }).then((r) => r.json());
  //
  //   if (!result.success) {
  //     navigate(-1);
  //     return;
  //   }
  //
  //   localStorage.setItem("theme", nextTheme);
  //   window.location.reload();
  // };

  const setLangHandler = async (event) => {
    const value = event.target.value;
    const nextLang = value ?? "ru";
    const token = getToken();
    if (token == "" || token == null) {
      navigate("/login");
      return;
    }
    const result = await fetch(DOMAIN + "/user/settings", {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lang: nextLang }),
    }).then((r) => r.json());

    if (!result.success) {
      navigate(-1);
      return;
    }

    localStorage.setItem("lang", nextLang);
    setLang(nextLang);
    await i18n.changeLanguage(nextLang);
  };

  const logout = () => {
    clearToken();
    navigate("/login");
  };

  const bindEmailToAccount = async () => {
    if (bindEmail == "" || bindPassword == "") {
      setBindEmailErrorMessage("Fill all fields");
      return;
    }
    if (bindPassword.length < 8) {
      setBindEmailErrorMessage("Password too short");
      return;
    }

    const token = getToken();
    if (token == "" || token == null) {
      navigate("/login");
      return;
    }

    setIsBindingEmail(true);
    setBindEmailErrorMessage("");
    try {
      const result = await fetch(DOMAIN + "/user/bind-email/request", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: bindEmail,
          password: bindPassword,
        }),
      }).then((r) => r.json());

      if (result.success) {
        setIsBindCodeSent(true);
        return;
      }

      let message = "Something went wrong";
      if (typeof result.message === "string" && result.message != "") {
        message = result.message;
      }
      setBindEmailErrorMessage(message);
    } catch {
      setBindEmailErrorMessage("Something went wrong");
    } finally {
      setIsBindingEmail(false);
    }
  };

  const confirmBindEmail = async () => {
    if (bindCode == "") {
      setBindEmailErrorMessage("Fill all fields");
      return;
    }

    const token = getToken();
    if (token == "" || token == null) {
      navigate("/login");
      return;
    }

    setIsBindingEmail(true);
    setBindEmailErrorMessage("");
    try {
      const result = await fetch(DOMAIN + "/user/bind-email/confirm", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: bindEmail,
          password: bindPassword,
          code: bindCode,
        }),
      }).then((r) => r.json());

      if (result.success) {
        setUsername(bindEmail.trim().toLowerCase());
        setBindEmail("");
        setBindPassword("");
        setBindCode("");
        setIsBindCodeSent(false);
        return;
      }

      let message = "Something went wrong";
      if (typeof result.detail === "string" && result.detail != "") {
        message = result.detail;
      } else if (typeof result.message === "string" && result.message != "") {
        message = result.message;
      }
      setBindEmailErrorMessage(message);
    } catch {
      setBindEmailErrorMessage("Something went wrong");
    } finally {
      setIsBindingEmail(false);
    }
  };

  const changePassword = async () => {
    if (currentPassword == "" || newPassword == "") {
      setPasswordErrorMessage("Fill all fields");
      return;
    }
    if (newPassword.length < 8) {
      setPasswordErrorMessage("Password too short");
      return;
    }

    const token = getToken();
    if (token == "" || token == null) {
      navigate("/login");
      return;
    }

    setIsPasswordChanging(true);
    setPasswordErrorMessage("");
    try {
      const result = await fetch(DOMAIN + "/user/change-password", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: currentPassword,
          new_password: newPassword,
        }),
      }).then((r) => r.json());

      if (result.success) {
        setCurrentPassword("");
        setNewPassword("");
        return;
      }

      let message = "Something went wrong";
      if (typeof result.message === "string" && result.message != "") {
        message = result.message;
      }
      setPasswordErrorMessage(message);
    } catch {
      setPasswordErrorMessage("Something went wrong");
    } finally {
      setIsPasswordChanging(false);
    }
  };

  const init = async () => {
    try {
      setIsLoading(true);

      const token = getToken();
      if (token == "" || token == null) {
        navigate("/login");
        return;
      }

      const result = await fetch(DOMAIN + "/user/settings", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((r) => r.json());

      if (result.success) {
        setLang(result.lang);
        // setTheme(result.theme);
        if ("username" in result) {
          setUsername(result.username);
        }
        if ("telegram_id" in result) {
          setTelegramId(result.telegram_id);
        }
      } else {
        navigate(-1);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        key={isLoading}
        className="container column-spacing border-padding background-regular column"
        variants={routeVariants}
        initial="initial"
        animate="final"
        exit="exit"
        style={{ position: "absolute" }}
      >
        {isLoading ? (
          <div className="center full-height">
            <Spinner />
          </div>
        ) : (
          <>
            <Header isBack={true}>
              <Title level="1" weight="3">
                {t("Settings")}
              </Title>
            </Header>
            {telegramId != "" && telegramId != null && (
              <Card>
                <div className="column card">
                  <div className="row">
                    <Banner
                      callout={t("Telegram account")}
                      header={telegramId}
                    />
                  </div>
                </div>
              </Card>
            )}
            {username != "" && username != null ? (
              <Card>
                <div className="column card">
                  <div className="row">
                    <Banner callout={t("Email")} header={username} />
                  </div>
                </div>
              </Card>
            ) : (
              <Card>
                <div className="column card">
                  {isBindCodeSent ? (
                    <>
                      <div className="row mb-1">
                        {t("The confirmation code has been sent to your email address")}
                      </div>
                      <Input
                        className="wide mb-1"
                        header={t("Confirmation code")}
                        value={bindCode}
                        onChange={(e) => setBindCode(e.target.value)}
                      />
                      <ErrorMessage errorMessage={bindEmailErrorMessage} />
                      <Button
                        mode="gray"
                        size="l"
                        className="row"
                        loading={isBindingEmail}
                        disabled={isBindingEmail}
                        onClick={confirmBindEmail}
                      >
                        {t("Confirm email")}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Input
                        type="email"
                        className="wide"
                        header={t("Email")}
                        value={bindEmail}
                        onChange={(e) => setBindEmail(e.target.value)}
                      />
                      <Input
                        type="password"
                        className="wide mb-1"
                        header={t("Password")}
                        value={bindPassword}
                        onChange={(e) => setBindPassword(e.target.value)}
                      />
                      <ErrorMessage errorMessage={bindEmailErrorMessage} />
                      <Button
                        mode="gray"
                        size="l"
                        className="row"
                        loading={isBindingEmail}
                        disabled={isBindingEmail}
                        onClick={bindEmailToAccount}
                      >
                        {t("Bind email")}
                      </Button>
                    </>
                  )}
                </div>
              </Card>
            )}
            <Card>
              <div className="column card" style={{ paddingBottom: "20px" }}>
                <div>
                  <Select
                    header={t("Interface language")}
                    onChange={setLangHandler}
                  >
                    <option value="ru" selected={"ru" === lang}>
                      {t("Russian")}
                    </option>
                    <option value="en" selected={"en" === lang}>
                      {t("English")}
                    </option>
                  </Select>
                </div>
                {/* <div className="mb-1">
                  <Select
                    header={t("Interface theme")}
                    onChange={setThemeHandler}
                  >
                    <option value="light" selected={"light" === theme}>
                      {t("Light")}
                    </option>
                    <option value="dark" selected={"dark" === theme}>
                      {t("Dark")}
                    </option>
                  </Select>
                </div> */}

              </div>
            </Card>
            {username != "" && username != null && (
              <Card>
                <div className="column card">
                  <Input
                    type="password"
                    className="wide"
                    header={t("Current password")}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <Input
                    type="password"
                    className="wide mb-1"
                    header={t("New password")}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <ErrorMessage errorMessage={passwordErrorMessage} />
                  <Button
                    mode="gray"
                    size="l"
                    className="row"
                    loading={isPasswordChanging}
                    disabled={isPasswordChanging}
                    onClick={changePassword}
                  >
                    {t("Change password")}
                  </Button>
                </div>
              </Card>
            )}
            <Button mode="gray" size="l" onClick={logout}>
              {t("Logout")}
            </Button>
          </>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
